import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div``;

export const Valid = styled.span`
  color: ${ColorPalette.HEX.GreenPantone};
  font-size: 12px;
`;

export const Invalid = styled.span`
  color: ${ColorPalette.HEX.RedRYB};
  font-size: 12px;
`;
